export default "__VITE_ASSET__762YQZ$o__"